export const STATE_OPTIONS = {
  initial: "initial",
  loading: "loading",
  success: "success",
} as const

export type NewsletterState = keyof typeof STATE_OPTIONS
